import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

export const useDeleteRiskAssessmentResultsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.riskAssessmentResult.delete.mutationOptions({
      onSuccess: async () => {
        // COI-889: router-level key — the hand-listed set missed
        // `assessmentResultCount`, the Findings left-nav badge.
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.assessment.pathKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.risk.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.risk.scores.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.risk.riskScoresByRiskId.queryKey(),
        });
      },
    }),
  });

  return {
    deleteRiskAssessmentResults: async (ids: string[]): Promise<void> => {
      await mutation.mutateAsync({ Ids: ids });
    },
    isLoading: mutation.isPending,
  };
};
